import { noop } from 'lodash/fp'
import { createAsyncAction } from 'typesafe-actions'

import { ReduxActionCallbacks } from 'packages/grimoire/src/utils'
import { RequestConfig } from 'packages/utils/store'

import { setIsCoverageStale } from '../../coverage/actions'
import { standardAvailabilityService } from '../standardAvailability.service'
import {
  StandardAvailabilityActionTypes,
  NormalizedStandardAvailabiltyApiResponse,
} from '../standardAvailability.types'

export const deleteStandardAvailabilityByIdAction = createAsyncAction(
  StandardAvailabilityActionTypes.DELETE_STANDARD_AVAILABILITY,
  StandardAvailabilityActionTypes.DELETE_STANDARD_AVAILABILITY_SUCCESS,
  StandardAvailabilityActionTypes.DELETE_STANDARD_AVAILABILITY_FAILURE,
)<
  RequestConfig<NormalizedStandardAvailabiltyApiResponse>,
  { standardAvailabilityId: string },
  Error
>()

export const deleteStandardAvailabilityById =
  (standardAvailabilityId: string, callbacks: ReduxActionCallbacks = {}) =>
  async dispatch => {
    const { onError = noop, onSuccess = noop } = callbacks
    try {
      const request =
        standardAvailabilityService.deleteStandardAvailabilityById.bind(
          null,
          standardAvailabilityId,
        )
      const result = await dispatch(
        deleteStandardAvailabilityByIdAction.request({ request }),
      )

      // Here result is empty, so we need to create a payload with the id
      dispatch(
        deleteStandardAvailabilityByIdAction.success({
          standardAvailabilityId,
        }),
      )

      dispatch(setIsCoverageStale(true))

      onSuccess()
      return result.normalized
    } catch (error) {
      dispatch(deleteStandardAvailabilityByIdAction.failure(error))
      onError()
      throw error
    }
  }
